import Vue from 'www/vue_components'
import vuetify from 'www/modules/vuetify-plugin'
import SnackbarNotification from './SnackbarNotification2.vue'
import { initI18n } from 'www/utils'

const mountElement = document.querySelector('.snackbar-notification-2')

const mountSnackbarNotification = async () => {
  await initI18n({ bundle: 'vue_components/common/core/SnackbarNotification' })

  if (mountElement) {
    new Vue({
      vuetify,
      el: mountElement,
      components: {
        SnackbarNotification,
      },
    })
  }
}

mountSnackbarNotification()
